// STATUS: draft — needs native-speaker check before live
// Portuguese visitor messages (task TR1, docs/modules/languages.md s2). European Portuguese (pt-PT) forms. Visitor keys only; missing keys fall back to en-GB.
export const ptVisitor = {
    'kiosk.pairing.title': 'Configurar este quiosque',
    'kiosk.pairing.hint': 'Introduza o código do portal CloudSign.',
    'kiosk.pairing.go': 'Associar',
    'kiosk.pairing.codeLabel': 'Código de associação',
    'kiosk.pairing.checking': 'A verificar o código…',
    'kiosk.pairing.clear': 'Limpar',
    'kiosk.pairing.back': 'Apagar o último dígito',
    'kiosk.pairing.invalid': 'Este código não é válido ou expirou. Peça um novo.',
    'kiosk.pairing.noNetwork': 'Não foi possível contactar o CloudSign. Verifique a rede Wi-Fi e tente novamente.',
    'kiosk.common.back': 'Voltar',
    'kiosk.common.next': 'Seguinte',
    'kiosk.common.continue': 'Continuar',
    'kiosk.common.cancel': 'Cancelar',
    'kiosk.common.yes': 'Sim',
    'kiosk.common.no': 'Não',
    'kiosk.welcome.tap': 'Toque aqui para registar a entrada ou a saída',
    'kiosk.welcome.offline': 'Offline: os registos são guardados e enviados mais tarde',
    'kiosk.home.title': 'O que pretende fazer?',
    'kiosk.home.signIn': 'Registar entrada',
    'kiosk.home.signOut': 'Registar saída',
    'kiosk.home.scan': 'Ler o meu crachá',
    'kiosk.groups.titleIn': 'Em nome de quem está a registar a entrada?',
    'kiosk.groups.titleOut': 'Em nome de quem está a registar a saída?',
    'kiosk.groups.hint': 'Escolha a opção que melhor se aplica.',
    'kiosk.groups.repeat': 'Membros habituais',
    'kiosk.pin.hint': 'Introduza o seu PIN de 4 dígitos.',
    'kiosk.pin.entered': '{count} de 4 dígitos introduzidos',
    'kiosk.pin.wrong': 'Esse PIN não está correto. Tente novamente.',
    'kiosk.pin.locked': 'Demasiados PIN incorretos. A introdução de PIN está bloqueada durante alguns minutos. Peça ajuda a alguém.',
    'kiosk.pin.clear': 'Limpar',
    'kiosk.pin.back': 'Apagar o último dígito',
    'kiosk.identify.title': 'Encontre o seu nome',
    'kiosk.identify.placeholder': 'Comece a escrever o seu nome',
    'kiosk.identify.none': 'Não foi encontrada ninguém com esse nome.',
    'kiosk.identify.addSelf': 'Não estou na lista',
    'kiosk.addSelf.title': 'Registe-se',
    'kiosk.name.title': 'Qual é o seu nome?',
    'kiosk.name.label': 'O seu nome',
    'kiosk.name.fullNameHint': 'Indique o seu primeiro nome e apelido.',
    'kiosk.already.message': 'A sua entrada já está registada. Pretende registar a saída em vez disso?',
    'kiosk.already.signOut': 'Registar a minha saída',
    'kiosk.questions.titleIn': 'Algumas perguntas rápidas',
    'kiosk.questions.titleOut': 'Antes de sair',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'Compreendi',
    'kiosk.questions.hostSearch': 'Escreva o nome da pessoa que vai visitar',
    'kiosk.questions.changeHost': 'Alterar',
    'kiosk.notices.progress': 'Aviso {n} de {total}',
    'kiosk.notices.accept': 'Li isto e aceito',
    'kiosk.notices.sign': 'Assinar',
    'kiosk.notices.signHere': 'Assine com o dedo, por favor.',
    'kiosk.signature.pad': 'Área de assinatura',
    'kiosk.signature.clear': 'Limpar assinatura',
    'kiosk.signature.captured': 'Assinatura guardada',
    'kiosk.photo.title': 'Fotografia',
    'kiosk.photo.hint': 'Olhe para a câmara e toque no botão.',
    'kiosk.photo.take': 'Tirar a minha fotografia',
    'kiosk.photo.getReady': 'Prepare-se…',
    'kiosk.photo.retake': 'Tirar outra vez',
    'kiosk.photo.use': 'Utilizar esta fotografia',
    'kiosk.photo.skip': 'Saltar a fotografia',
    'kiosk.photo.failed': 'A fotografia não funcionou. Tente novamente.',
    'kiosk.photo.noCamera': 'A câmara não está disponível. Pode continuar sem fotografia.',
    'kiosk.photo.privacy': 'A sua fotografia só é utilizada para o crachá e para o registo da visita.',
    'kiosk.badge.title': 'O seu crachá',
    'kiosk.badge.ask': 'Pretende um crachá?',
    'kiosk.badge.yes': 'Imprimir o meu crachá',
    'kiosk.badge.no': 'Não, obrigado',
    'kiosk.badge.printing': 'A imprimir o seu crachá…',
    'kiosk.badge.done': 'Por favor, retire o seu crachá',
    'kiosk.badge.failed': 'Lamentamos, o crachá não foi impresso. A sua entrada está registada. Peça um crachá na receção.',
    'kiosk.signout.title': 'Encontre o seu nome para registar a saída',
    'kiosk.signout.search': 'Pesquisar por nome',
    'kiosk.signout.hiddenHint': 'Por privacidade, os nomes não são apresentados. Escreva o seu nome ou leia o seu crachá.',
    'kiosk.signout.empty': 'Não há ninguém registado.',
    'kiosk.signout.noMatch': 'Não foi encontrada ninguém. Tente novamente ou leia o seu crachá.',
    'kiosk.signout.unnamed': 'Visitante',
    'kiosk.scan.title': 'Leia o seu crachá',
    'kiosk.scan.hint': 'Mantenha o código QR do crachá em frente à câmara.',
    'kiosk.scan.allow': 'Permitir a câmara',
    'kiosk.scan.noCamera': 'A câmara não está disponível. Escolha o seu nome na lista.',
    'kiosk.scan.notBadge': 'Este não é um crachá CloudSign. Tente novamente.',
    'kiosk.scan.notSignedIn': 'Este crachá não está registado aqui. Escolha o seu nome na lista.',
    'kiosk.finish.inTitle': 'Obrigado, {name}',
    'kiosk.finish.inMessage': 'A sua entrada está registada.',
    'kiosk.finish.outTitle': 'Adeus, {name}',
    'kiosk.finish.outMessage': 'A sua saída está registada. Boa viagem!',
    'kiosk.finish.tap': 'Toque para terminar',
    'kiosk.update.title': 'Este quiosque precisa de uma atualização',
    'kiosk.update.message': 'Este quiosque precisa de uma atualização antes de poder registar a sua entrada. Pergunte na receção.',
    'kiosk.update.short': 'Precisa de atualização',
    'kiosk.error.required': 'Responda a esta pergunta, por favor.',
    'kiosk.error.mustAcknowledge': 'Marque a caixa para confirmar.',
    'kiosk.error.nameRequired': 'Escreva o seu nome, por favor.',
    'kiosk.error.fullName': 'Indique o seu primeiro nome e apelido.',
    'kiosk.error.tooLong': 'Essa resposta é demasiado longa.',
    'kiosk.error.number': 'Introduza um número.',
    'kiosk.error.wholeNumber': 'Introduza um número inteiro.',
    'kiosk.error.range': 'Esse número está fora do intervalo permitido.',
    'kiosk.error.email': 'Introduza um endereço de correio eletrónico válido.',
    'kiosk.error.phone': 'Introduza um número de telefone válido.',
    'kiosk.error.date': 'Introduza uma data como 2026-12-31.',
    'kiosk.error.answerNotAllowed': 'Esta resposta significa que não pode registar-se aqui. Fale com a receção, por favor.',
    'kiosk.print.state.ready': 'A impressora está pronta',
    'kiosk.print.state.no_media': 'A impressora ficou sem etiquetas',
    'kiosk.print.state.cover_open': 'A tampa da impressora está aberta',
    'kiosk.print.state.media_mismatch': 'Estão carregadas as etiquetas erradas na impressora',
    'kiosk.print.state.busy': 'A impressora está ocupada',
    'kiosk.print.state.error': 'A impressora comunicou um problema',
    'kiosk.print.state.unreachable': 'Não é possível contactar a impressora',
    'kiosk.print.state.unknown': 'O estado da impressora é desconhecido',
    'kiosk.home.expected': 'Tenho visita marcada',
    'kiosk.home.scanCode': 'Ler o meu código QR',
    'kiosk.scan.titleCode': 'Leia o seu código QR',
    'kiosk.scan.hintCode': 'Mantenha à frente da câmara o código QR do e-mail, do cartão ou do crachá.',
    'kiosk.scan.invalid': 'Este código QR não é válido aqui. Tente novamente ou escolha o seu nome na lista.',
    'kiosk.scan.notSupported': 'Este quiosque não consegue usar este tipo de código QR. Escolha o seu nome na lista.',
    'kiosk.scan.unknownMember': 'Este código QR não é reconhecido neste quiosque. Escolha o seu nome na lista.',
    'kiosk.scan.oldCode': 'Este código QR foi substituído por um novo. Utilize o mais recente ou escolha o seu nome.',
    'kiosk.scan.notHere': 'Este código QR não é para este quiosque.',
    'kiosk.scan.notExpected': 'Não estamos à espera deste código QR hoje. Pergunte na receção.',
    'kiosk.scan.cancelled': 'Esta visita foi cancelada. Pergunte na receção.',
    'kiosk.scan.alreadyArrived': 'Este código QR já foi utilizado para registar uma entrada.',
    'kiosk.scan.expired': 'Este código QR expirou. Pergunte na receção.',
    'kiosk.expected.title': 'Quem é?',
    'kiosk.expected.search': 'Comece a escrever o seu nome',
    'kiosk.expected.exactHint': 'Escreva o seu nome completo exatamente como nos foi indicado.',
    'kiosk.expected.requiredHint': 'Tem de estar previsto para registar a entrada aqui. Encontre o seu nome ou leia o seu código QR.',
    'kiosk.expected.none': 'Não encontrámos este nome na lista de hoje. Pergunte na receção.',
    'kiosk.expected.empty': 'Neste momento não há ninguém previsto.',
    'kiosk.expected.visiting': 'Visita a {host}',
    'kiosk.expected.required': 'Tem de estar previsto para registar a entrada aqui. Pergunte na receção.',
    'kiosk.signout.outMark': 'Saída',
    'kiosk.signout.outToday': 'Saída registada hoje',
    'kiosk.hostReply.on_my_way': '{host} está a caminho.',
    'kiosk.hostReply.please_wait': '{host} pede que aguarde um momento.',
    'kiosk.hostReply.someone': 'O seu anfitrião',
    'kiosk.hostReply.dismiss': 'OK',
    'kiosk.evacuation.notAllowed': 'Não é possível iniciar uma evacuação a partir deste quiosque.',
    'kiosk.evacuation.wrongPin': 'Esse PIN não está correto.',
    'kiosk.evacuation.pinLocked': 'Demasiados PIN incorretos. Aguarde alguns minutos, por favor.',
    'kiosk.evacuation.startFailed': 'Não foi possível iniciar a evacuação. Tente novamente.',
    'kiosk.nfc.enrolOffline': 'Este quiosque está offline. Os cartões só podem ser registados quando estiver ligado.',
    'kiosk.nfc.enrolExpired': 'Este registo de cartão terminou ou expirou.',
    'kiosk.nfc.enrolFailed': 'Não foi possível registar este cartão. Tente outro.',
    'kiosk.nfc.enrolTapAgain': 'Aproxime o cartão novamente, por favor.',
    'kiosk.common.ok': 'OK',
    'kiosk.welcome.stale': 'Este quiosque esteve offline durante muito tempo. Informe a receção, por favor.',
    'kiosk.welcome.busy': 'O local está movimentado neste momento. Se estiver de visita, informe a receção, por favor.',
    'kiosk.welcome.evacuation': 'Evacuação',
    'kiosk.home.delivery': 'Estou a entregar uma encomenda',
    'kiosk.check.seeReceptionTitle': 'Dirija-se à receção, por favor',
    'kiosk.check.warnTitle': 'Antes de continuar',
    'kiosk.full.short': 'O local está cheio',
    'kiosk.full.title': 'O local está cheio',
    'kiosk.full.message': 'Neste momento não podemos registar mais visitantes. Dirija-se à receção, por favor.',
    'kiosk.induction.subtitle': 'Integração de segurança no local',
    'kiosk.induction.unavailable': 'A integração de segurança não está disponível neste quiosque. Dirija-se à receção, por favor.',
    'kiosk.induction.videoMissing': 'O vídeo ainda não está neste quiosque. Leia o texto abaixo, por favor.',
    'kiosk.induction.pdfNote': 'Leia o texto da integração abaixo, por favor. Pergunte na receção se pretender o documento.',
    'kiosk.induction.wait': 'Aguarde {seconds} segundos, por favor',
    'kiosk.induction.startQuiz': 'Iniciar as perguntas',
    'kiosk.induction.question': 'Pergunta {n} de {total}',
    'kiosk.induction.chooseMany': 'Escolha todas as respostas corretas.',
    'kiosk.induction.finish': 'Concluir',
    'kiosk.induction.retryTitle': 'Ainda não',
    'kiosk.induction.retryMessage': 'Algumas respostas não estavam corretas. Tente novamente {count}.',
    'kiosk.induction.retryButton': 'Tentar novamente',
    'kiosk.permits.title': 'As suas autorizações de trabalho',
    'kiosk.permits.unavailable': 'Não é possível mostrar as autorizações neste momento. Dirija-se à receção antes de começar a trabalhar.',
    'kiosk.permits.allAccepted': 'Aceitou todas as suas autorizações.',
    'kiosk.permits.progress': 'Autorização {n} de {total}',
    'kiosk.permits.valid': 'De {from} até {until}',
    'kiosk.permits.conditions': 'Condições',
    'kiosk.permits.precautions': 'Precauções',
    'kiosk.permits.signHere': 'Assine aqui para aceitar, {name}',
    'kiosk.permits.accept': 'Aceito esta autorização',
    'kiosk.nfc.blocked': 'Este cartão foi bloqueado',
    'kiosk.nfc.unknown': 'Cartão não reconhecido',
    'kiosk.nfc.enrolTitle': 'Registo de cartões',
    'kiosk.nfc.enrolProgress': '{done} de {total} concluídos',
    'kiosk.nfc.enrolTapFor': 'Aproxime o cartão de',
    'kiosk.nfc.enrolHold': 'Encoste o cartão na parte de trás do tablet.',
    'kiosk.nfc.enrolSaving': 'A guardar…',
    'kiosk.nfc.enrolOk': 'Cartão guardado.',
    'kiosk.nfc.enrolDone': 'Todos os cartões foram registados',
    'kiosk.nfc.noReader': 'Não há nenhum leitor de cartões ativado neste quiosque.',
    'kiosk.evacuation.title': 'EVACUAÇÃO',
    'kiosk.evacuation.drillTitle': 'EXERCÍCIO DE INCÊNDIO',
    'kiosk.evacuation.startTitle': 'Iniciar uma evacuação',
    'kiosk.evacuation.confirmTitle': 'Iniciar uma evacuação?',
    'kiosk.evacuation.confirmMessage': 'Isto alerta todas as pessoas no local e abre a chamada.',
    'kiosk.evacuation.confirmStart': 'Iniciar evacuação',
    'kiosk.evacuation.leave': 'Sair da chamada',
    'kiosk.evacuation.leaveTitle': 'Introduza o PIN para sair da chamada',
    'kiosk.evacuation.returnBanner': 'Evacuação em curso. Toque para voltar à chamada.',
    'kiosk.evacuation.offline': 'Offline: as suas marcações são guardadas e enviadas quando a rede voltar.',
    'kiosk.evacuation.localOnly': 'Iniciada neste quiosque offline. Será integrada no portal quando a rede voltar.',
    'kiosk.evacuation.countUnaccounted': 'Ainda não localizados',
    'kiosk.evacuation.countSafe': 'Em segurança',
    'kiosk.evacuation.countMissing': 'Desaparecidos',
    'kiosk.evacuation.countTotal': 'No local',
    'kiosk.evacuation.allPoints': 'Todos',
    'kiosk.evacuation.search': 'Pesquisar por nome',
    'kiosk.evacuation.onlyOpen': 'Ainda não em segurança',
    'kiosk.evacuation.loading': 'A carregar a chamada…',
    'kiosk.evacuation.nobody': 'Ninguém para mostrar.',
    'kiosk.evacuation.safe': 'Em segurança',
    'kiosk.evacuation.markedSafe': 'EM SEGURANÇA (toque para anular)',
    'kiosk.evacuation.missing': 'Desaparecido',
    'kiosk.evacuation.markedMissing': 'DESAPARECIDO (toque para anular)',
    'kiosk.evacuation.host': 'Anfitrião: {name}',
    'kiosk.evacuation.check': 'VERIFICAR',
    'kiosk.evacuation.permits': '{count} autorização(ões) aberta(s)',
    'kiosk.contactless.qrLabel': 'Leia este código com o telemóvel para registar a entrada',
    'kiosk.contactless.scanMe': 'Registe-se com o seu telemóvel',
    'kiosk.courier.whoTitle': 'Para quem é a encomenda?',
    'kiosk.courier.whoHint': 'Escreva algumas letras do nome.',
    'kiosk.courier.search': 'Nome da pessoa',
    'kiosk.courier.useName': 'Utilizar «{name}»',
    'kiosk.courier.useNameHint': 'A receção encaminhará',
    'kiosk.courier.carrierTitle': 'De que empresa vem?',
    'kiosk.courier.forName': 'Encomenda para {name}',
    'kiosk.courier.other': 'Outra',
    'kiosk.courier.otherLabel': 'Nome da empresa',
    'kiosk.courier.countTitle': 'Quantas encomendas?',
    'kiosk.courier.howMany': 'Número de encomendas',
    'kiosk.courier.save': 'Concluído',
    'kiosk.courier.thanks': 'Obrigado',
    'kiosk.courier.thanksMessage': 'Informámos o destinatário de que a encomenda chegou.',
    'kiosk.support.pinTitle': 'Apoio: introduza o PIN',
    'kiosk.support.title': 'Apoio',
    'kiosk.support.close': 'Fechar',
    'kiosk.support.network': 'Rede',
    'kiosk.support.online': 'Online',
    'kiosk.support.offline': 'Offline',
    'kiosk.support.queue': 'À espera de envio',
    'kiosk.support.oldest': 'Mais antigo à espera desde',
    'kiosk.support.none': 'Nenhum',
    'kiosk.support.deadLetters': 'Recusados pelo servidor (não enviados)',
    'kiosk.support.deadHelp': 'Estes itens foram recusados pelo servidor e permanecem neste quiosque. Informe o administrador; a página do dispositivo no portal mostra a contagem.',
    'kiosk.support.configAge': 'Definições atualizadas pela última vez',
    'kiosk.support.ageUnknown': 'Nunca',
    'kiosk.support.ageMinutes': 'há {n} minutos',
    'kiosk.support.ageHours': 'há {n} horas',
    'kiosk.support.ageDays': 'há {n} dias',
    'kiosk.support.nfc': 'Leitor de cartões',
    'kiosk.support.nfcReady': 'Pronto',
    'kiosk.support.nfcOff': 'Desligado',
    'kiosk.support.nfcNone': 'Não instalado',
    'kiosk.support.media': 'Vídeos guardados',
    'kiosk.support.mediaMb': '{mb} MB',
    'kiosk.support.headcount': 'Pessoas no local (este quiosque)',
    'kiosk.finish.poweredBy': 'Com a tecnologia CloudSign',
    'kiosk.badge.noMedia': 'A impressora de crachás ficou sem etiquetas. A sua entrada está registada. Informe a receção, por favor.',
    'kiosk.badge.mediaMismatch': 'A impressora de crachás tem as etiquetas erradas. A sua entrada está registada. Informe a receção, por favor.',
    'kiosk.badge.coverOpen': 'A tampa da impressora de crachás está aberta. A sua entrada está registada. Informe a receção, por favor.',
    'kiosk.member.menuTitle': 'O que pretende fazer?',
    'kiosk.member.signIn': 'Registar a minha entrada',
    'kiosk.member.updatePhoto': 'Atualizar a minha fotografia',
    'kiosk.member.sendInvite': 'Enviar-me o convite para a aplicação',
    'kiosk.memberPhoto.title': 'Atualize a sua fotografia',
    'kiosk.memberPhoto.saved': 'A sua fotografia foi atualizada.',
    'kiosk.memberPhoto.failed': 'Não foi possível guardar a fotografia. Tente novamente ou pergunte na receção.',
    'kiosk.memberPhoto.offline': 'Este quiosque está offline, por isso a fotografia não pode ser atualizada neste momento.',
    'kiosk.memberPhoto.notAllowed': 'A fotografia não pode ser atualizada no quiosque. Pergunte na receção.',
    'kiosk.invite.title': 'Obtenha a aplicação CloudSign',
    'kiosk.invite.sent': 'Enviámos-lhe por e-mail uma ligação para configurar a aplicação. Verifique a sua caixa de entrada.',
    'kiosk.invite.noEmail': 'Não temos o seu endereço de e-mail, por isso não foi possível enviar o convite. Pergunte na receção.',
    'kiosk.invite.tooMany': 'Pediu demasiados convites hoje. Tente novamente amanhã.',
    'kiosk.invite.failed': 'Não foi possível enviar o convite. Tente novamente ou pergunte na receção.',
    'kiosk.invite.offline': 'Este quiosque está offline, por isso não é possível enviar um convite neste momento.',
    'kiosk.invite.sending': 'A enviar o seu convite…',
    'kiosk.language.choose': 'Escolha o seu idioma',
    'kiosk.language.button': 'Idioma',
    'public.language.label': 'Idioma',
    'contactless.thank_you': 'Obrigado. A sua entrada está registada.',
    'contactless.thank_you_out': 'Obrigado. A sua saída está registada.',
    'contactless.poster.title': 'Leia para registar a entrada',
    'contactless.poster.hint': 'Aponte a câmara do telemóvel para o código. Não é necessária nenhuma aplicação.',
    'check.safety_check.refused': 'Dirija-se à receção antes de registar a entrada.',
    'check.safety_check.alert': 'Admitido com um alerta para a receção (verificação de segurança).',
    'check.compliance.refused': 'Falta um documento obrigatório ou está expirado. Dirija-se à receção, por favor.',
    'check.compliance.warned': 'Falta um documento obrigatório ou está expirado.',
    'check.induction.required': 'Complete primeiro a integração de segurança no local.',
    'check.capacity.full': 'O local está cheio neste momento. Dirija-se à receção, por favor.',
    'check.capacity.warned': 'Registado enquanto o local estava acima da capacidade.',
    'check.offline': 'Registado enquanto o quiosque estava offline.',
};
//# sourceMappingURL=pt.js.map